<template>
  <div class="custom-qr-code">
    <template v-if="$props.template && $props.template.color_picker">
      <div class="customization-title">
        {{ props.template.title }}
      </div>
      <ColorPicker
        @change-colors="changeColors"
        :value="$props.template.values[0]"
        :type="$props.template.color_picker"
        :id="'qrCode'"
      />
    </template>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import EventBus from '@/services/eventbus'
import { EVENT_CHANGE_COLOR_QR_CODE } from '@/utils'
import ColorPicker from '@/ui-kits/ColorPicker.vue'

const props = withDefaults(
  defineProps<{
    template: { title: string; values: string[]; color_picker: string }
  }>(),
  {}
)

const BACKGROUND_COLOR_DEFAULT = '#000000'
const colors = ref([BACKGROUND_COLOR_DEFAULT])

onMounted(() => {
  if (props.template.values?.length) {
    colors.value = props.template.values[0].split(',')
  } else {
    colors.value = [BACKGROUND_COLOR_DEFAULT]
  }
})

function changeColors(listColor: string[]) {
  if (listColor?.length) {
    colors.value = listColor
  } else {
    colors.value = [BACKGROUND_COLOR_DEFAULT]
  }
  EventBus.trigger(EVENT_CHANGE_COLOR_QR_CODE, colors.value[0])
}
</script>
